import React, {Component} from "react";
import RedirectToPlatform from "../components/RedirectToPlatform";
import Invite from "../components/Invite";
import "./Home.css";
import Cookies from 'universal-cookie';

const queryString = require('query-string');

const cookies = new Cookies();

const mixpanel = require('mixpanel-browser');
mixpanel.init("c805ed9c4e73d1093d18978a1d79ed1b");

export default class Home extends Component {
    render() {
        return (
            <div className="Home">
                <div className="p-a-md box-color r box-shadow-z1 text-color m-a">
                    <RedirectToPlatform props={this.props}></RedirectToPlatform>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js